import * as React from 'react';
import styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const SuggestModalMobile = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("ul", {
    ref: ref,
    role: "listbox",
    className: styles['list'],
    "data-testid": "suggest-modal-mobile",
    children: props.children
  });
});
SuggestModalMobile.displayName = 'SuggestModalMobile';